module.exports = __webpack_public_path__ + "img/logo-bw.ba579b86.svg";